import { Component, Input, OnInit } from '@angular/core';
import { StateService, Transition } from '@uirouter/angular';
import { BaseUserRoleDTO } from 'src/app/model/base/base-user-role-dto.model';
import { PermissionTypes } from 'src/app/model/enum/permission-types.enum';
import { UserRoleHelper } from 'src/app/model/helpers/user-role/user-role.helper';
import { ObservationSummaryDTO } from 'src/app/model/observation/observation-summary-dto.model';
import { DEFAULT_RUBRIC_LANGUAGE_LINK } from 'src/app/properties/observations/rubric/rubric.constants';
import { ResourceData } from 'src/app/services/resource/resource.service';
import { FileAttachment } from '../../../model/attachment/file-attachment.model';
import { ObservationTypes } from './../../../model/enum/observation-types.enum';

@Component({
    selector: 'app-observation-nav',
    templateUrl: './observation-nav.component.html',
    styleUrls: ['./observation-nav.component.scss']
})
export class ObservationNavComponent implements OnInit {
    @Input() title?: string;
    @Input() observationSummary?: ObservationSummaryDTO;
    @Input() observationType?: number;
    @Input() observationEvaluator?: string;
    @Input() observationSchoolYear?: string;
    @Input() createdDate?: Date;
    @Input() observationFiles: FileAttachment[] = [];
    @Input() pluralizeObservationType: boolean = true;

    @Input() isDashboard: boolean = false;
    @Input() observationId?: string;

    @Input() resourceFile: ResourceData = {};
    @Input() userRole?: BaseUserRoleDTO;
    guidanceLink: string = '';
    rubricLanguageLink: string = '';
    frameworkLabel: string = 'Framework';

    PermissionTypes = PermissionTypes;
    observationTypeName?: string = "";

    constructor(
        public stateService: StateService,
        public transition: Transition
    ) { }

    ngOnInit(): void {
        this.observationTypeName = ObservationTypes.GetObservationType(this.observationType)?.Name;
        this.guidanceLink = ObservationTypes.GetGuidanceLinkURL(this.observationType);
        if (ObservationTypes.HasRubricLanaguge(this.observationType)) {
            this.rubricLanguageLink = this.resourceFile['RubricPDF.Text'] ?? DEFAULT_RUBRIC_LANGUAGE_LINK;
        }
        this.frameworkLabel = this.getFrameworkLabel();
    }


    returnToSummary() {
        const { userId } = this.transition.params();


        this.stateService
            .go('authenticated.user-summary.observation-summary', {
                observationType: ObservationTypes.GetUserSummaryTabIndex(this.observationType),
                userId
            });
    }

    returnToDashboard() {
        const { userId } = this.transition.params();

        let observationType = ObservationTypes.GetObservationTypeURLTag(this.observationType);
        this.stateService
            .go('authenticated.user-summary.' + observationType + '.dashboard.view', {
                observationId: this.observationId ?? this.observationSummary?.observationId,
                userId
            }, { reload: true });
    }

    refreshListing() {
        this.stateService.reload();
    }


    getFrameworkLabel(){
        if(this.userRole){
            if(UserRoleHelper.isUserroleSupervisor(this.userRole)){
                return ' for Leadership';
            }
            return ' - ' + this.userRole.displayName;
        } 
        return '';
    }
}
